export default {
    styles: {
      'casual': {
        id: "casual",
        dispayName: "Casual"
      },
      'business': {
        id: "business",
        dispayName: "Business"
      },
      'business-casual': {
        id: "casual",
        dispayName: "Casual"
      },
    },
    colors: {
      'голубой': {
        id: "blue",
        dispayName: "Голубой"
      },
      'серый': {
        id: 'gray',
        dispayName: "Серый"
      },
    },
  }